import { Component, Input, OnInit } from '@angular/core';
import { FrequencyFormatPipe } from 'src/shared/pipes/plans-frequency-format.pipe';

@Component({
    selector: 'frequency-request-times',
    templateUrl: './frequency-request-times.component.html',
    standalone: false
})
export class FrequencyRequestTimesComponent implements OnInit {
  @Input() frequency: string;
  formattedFrequency: string;

  constructor(private frequencyFormatPipe: FrequencyFormatPipe) {}

  ngOnInit() {
    if (this.frequency === 'once') {
      this.formattedFrequency = 'One Time';
    } else {
      this.formattedFrequency = this.frequencyFormatPipe.transform(this.frequency);
    }
  }
}
